import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../../redux/messages';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getBeneficers = (data, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_BENEFICERS,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
     
    const resp = await client.get(iType === 1 ? '/api/app/Formal_Dependientes_Economico/' : `/api/app/Funcional_Beneficiario_Seguro/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: data
    });
    dispatch({
      type: actions.GET_BENEFICERS,
      payload: {
        beneficers: resp.data.data,
        beneficersLength: resp.data.count
      }
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_BENEFICERS,
      payload: false
    });
  }
}

export const saveBeneficers = (data, form, setValid, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_BENEFICERS,
      payload: true
    });
  
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.post(iType === 1 ? '/api/app/Formal_Dependientes_Economico/' : '/api/app/Funcional_Beneficiario_Seguro/', data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    const { beneficers, beneficersLength } = getState().beneficers;
    const aBeneficers = [...beneficers, resp.data];
    dispatch({
      type: actions.GET_BENEFICERS,
      payload: {
        beneficers: aBeneficers,
        beneficersLength: beneficersLength + 1
      }
    });
    toastr.success(messages.successMessage);
    form.reset();
    setValid(false);
  } catch (ex) {
    debugger;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_BENEFICERS,
      payload: false
    });
  }
}

export const editBeneficers = (data, id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_BENEFICERS,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.put(iType === 1 ? `/api/app/Formal_Dependientes_Economico/${id}/` : `/api/app/Funcional_Beneficiario_Seguro/${id}/`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { beneficers, beneficersLength } = getState().beneficers;
    beneficers[index] = resp.data;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_BENEFICERS,
      payload: {
        beneficers: beneficers,
        beneficersLength: beneficersLength
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_BENEFICERS,
      payload: false
    });
  }
}

export const deleteBeneficers = (id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_BENEFICERS,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    await client.delete(iType === 1 ? `/api/app/Formal_Dependientes_Economico/${id}/` : `/api/app/Funcional_Beneficiario_Seguro/${id}/`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { beneficers, beneficersLength } = getState().beneficers;
    beneficers.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_BENEFICERS,
      payload: {
        beneficers: beneficers,
        beneficersLength: beneficersLength -1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_BENEFICERS,
      payload: false
    });
  }
}
